/** @jsx h */
import { h } from 'preact'

import Facility from './Facility'
import t from '../../../../utils/translate'

const Facilities = ({ facilities }) => {
  if (facilities === undefined || facilities.length === 0) {
    return null
  }

  return (
    <section>
      <h3 class='ModalCard-heading'>{t('proof_points.js.recycling.results.facilities.title')}</h3>
      <ul class='ModalCard-list ModalCard-list--block'>
        {facilities.map((facility, index) =>
          <Facility {...facility} key={`facility-${index}`} />
        )}
      </ul>
    </section>
  )
}

export default Facilities
